/* WB Landing X: product-mode bundle picker (B) and quiz (C). Runs after wb-lp-v3.js, which owns size, grid cards, cart count and the set bar. */
(function(){
  var root = document.getElementById('lp3'); if(!root) return;
  var SIZE_KEY = 'wb_lp3_size';
  var sizeLabels = {1:'38–42mm', 2:'44–49mm'};
  function currentSize(){ var s = 1; try { s = parseInt(localStorage.getItem(SIZE_KEY)||'1',10) || 1; } catch(e){} return s; }
  function sizeMatches(val, size){
    if(!val) return false;
    var v = String(val).toUpperCase();
    return size === 1 ? (v.indexOf('38')===0 || v.indexOf('40')===0 || v.indexOf('41')===0) : (v.indexOf('44')===0 || v.indexOf('45')===0 || v.indexOf('46')===0 || v.indexOf('49')===0);
  }
  function optVal(v, idx){ return idx===0 ? v.o1 : idx===1 ? v.o2 : idx===2 ? v.o3 : null; }
  function shortColor(s){ return String(s||'').replace(/^(Perla|Nova|Atlanta|Sorelle|Kyra|Themis|Terra|Stella|Granum|Arya|Kyoto|Tokyo|Iola)\s+/i,'').replace(/\s+Hardware$/i,''); }
  /* Format cents the way the sample money string is formatted (keeps the market's currency symbol and separators). */
  function fmtLike(sample, cents){
    var m = String(sample||'').match(/[\d.,]+/); if(!m) return sample;
    var num = m[0];
    var dec = null;
    if(/[.,]\d{2}$/.test(num)) dec = num.charAt(num.length-3);
    var thou = dec === '.' ? ',' : dec === ',' ? '.' : (num.indexOf(',')>-1 ? ',' : num.indexOf('.')>-1 ? '.' : ',');
    var whole = Math.floor(cents/100), frac = String(cents%100); if(frac.length<2) frac = '0'+frac;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out = dec ? (w + dec + frac) : w;
    return String(sample).replace(num, out);
  }
  function postItems(items){
    return fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); });
  }
  function toast(msg){ var t = document.getElementById('lp3-toast'); if(!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('is-on'); }, 2600); }
  /* a size remembered from another page: make every size button agree with it on load */
  (function(){ var s = currentSize(); root.querySelectorAll('[data-lp3-size]').forEach(function(b){ var on = parseInt(b.getAttribute('data-lp3-size'),10) === s; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); })();

  /* ================= B: ONE PRODUCT, SET OF 3 ================= */
  var pdp = root.querySelector('[data-lpx-pdp]');
  if(pdp){
    var variants = [];
    try { variants = JSON.parse(pdp.querySelector('[data-lpx-variants]').textContent); } catch(e){}
    var sizeIdx = parseInt(pdp.getAttribute('data-size-idx'),10), colorIdx = parseInt(pdp.getAttribute('data-color-idx'),10);
    var slots = Array.prototype.slice.call(pdp.querySelectorAll('[data-lpx-slot]'));
    var mainImg = pdp.querySelector('[data-lpx-main]');
    var addBtn = pdp.querySelector('[data-lpx-add]'), addLabel = pdp.querySelector('[data-lpx-add-label]'), addPrice = pdp.querySelector('[data-lpx-add-price]'), status = pdp.querySelector('[data-lpx-status]');
    var baseLabel = addLabel.textContent;
    var mode = 'set';
    var colors = [];
    function colorList(){ var seen = {}, out = []; variants.forEach(function(v){ var c = optVal(v, colorIdx); if(c && !seen[c]){ seen[c] = 1; out.push(c); } }); return out; }
    function variantFor(color, size){
      var list = variants.filter(function(v){ return (colorIdx < 0 || optVal(v, colorIdx) === color) && (sizeIdx < 0 || sizeMatches(optVal(v, sizeIdx), size)); });
      return list.find(function(v){ return v.available; }) || list[0] || null;
    }
    function availableColors(size){ return colorList().filter(function(c){ var v = variantFor(c, size); return v && v.available; }); }
    /* start with three different colours so it reads as a set, first one = the product's default */
    (function init(){
      var size = currentSize(); var avail = availableColors(size); var all = colorList();
      var first = pdp.querySelector('[data-lpx-slot="0"] [data-lpx-slot-name]'); var def = first ? first.textContent.trim() : null;
      if(def && avail.indexOf(def) === -1) def = avail[0] || all[0];
      colors = [def];
      avail.concat(all).forEach(function(c){ if(colors.length < 3 && colors.indexOf(c) === -1) colors.push(c); });
      while(colors.length < 3) colors.push(def);
    })();
    function render(){
      var size = currentSize();
      var vs = colors.map(function(c){ return variantFor(c, size); });
      slots.forEach(function(slot, i){
        var v = vs[i];
        var name = slot.querySelector('[data-lpx-slot-name]'); if(name) name.textContent = shortColor(colors[i]) + (v && !v.available ? ' (sold out in this size)' : '');
        slot.querySelectorAll('[data-lpx-chip]').forEach(function(ch){
          var c = ch.getAttribute('data-value'); var cv = variantFor(c, size);
          ch.classList.toggle('is-on', c === colors[i]); ch.setAttribute('aria-selected', c === colors[i] ? 'true' : 'false');
          ch.classList.toggle('is-off', !cv || !cv.available);
        });
      });
      var v0 = vs[0];
      if(v0 && v0.img && mainImg.getAttribute('src') !== v0.img){ mainImg.style.opacity = .35; mainImg.onload = function(){ mainImg.style.opacity = 1; }; mainImg.src = v0.img; pdp.querySelectorAll('[data-lpx-thumb]').forEach(function(t){ t.classList.remove('is-on'); }); }
      var sample = v0 ? v0.price_f : (variants[0] ? variants[0].price_f : '$0.00');
      var single = v0 ? v0.price : 0;
      var full = vs.reduce(function(s, v){ return s + (v ? v.price : 0); }, 0);
      var cheapest = Math.min.apply(null, vs.map(function(v){ return v ? v.price : 0; }));
      var set = full - cheapest;
      var el;
      if((el = pdp.querySelector('[data-lpx-single-price]'))) el.textContent = fmtLike(sample, single);
      if((el = pdp.querySelector('[data-lpx-set-full]'))) el.textContent = fmtLike(sample, full);
      if((el = pdp.querySelector('[data-lpx-set-price]'))) el.textContent = fmtLike(sample, set);
      if((el = pdp.querySelector('[data-lpx-set-each]'))) el.textContent = fmtLike(sample, Math.round(set/3)) + ' a band';
      var ok = mode === 'set' ? vs.every(function(v){ return v && v.available; }) : (v0 && v0.available);
      addLabel.textContent = mode === 'set' ? baseLabel : 'Add this band';
      addPrice.textContent = fmtLike(sample, mode === 'set' ? set : single);
      if(ok){ addBtn.removeAttribute('disabled'); } else { addBtn.setAttribute('disabled','disabled'); addLabel.textContent = 'Pick another colour, sold out in this size'; }
      pdp.classList.toggle('is-single', mode === 'single');
      pdp._lpx = {vs: vs, set: set, single: single, sample: sample};
      renderSticky();
    }
    slots.forEach(function(slot, i){
      slot.querySelectorAll('[data-lpx-chip]').forEach(function(ch){
        ch.addEventListener('click', function(){
          if(ch.classList.contains('is-off')) return;
          colors[i] = ch.getAttribute('data-value'); render();
          if(i > 0){ var v = variantFor(colors[i], currentSize()); if(v && v.img){ mainImg.style.opacity = .35; mainImg.onload = function(){ mainImg.style.opacity = 1; }; mainImg.src = v.img; pdp.querySelectorAll('[data-lpx-thumb]').forEach(function(t){ t.classList.remove('is-on'); }); } }
        });
      });
    });
    pdp.querySelectorAll('input[name="lpx-opt"]').forEach(function(r){ r.addEventListener('change', function(){ mode = r.value; render(); }); });
    pdp.querySelectorAll('[data-lpx-thumb]').forEach(function(t){
      t.addEventListener('click', function(){ pdp.querySelectorAll('[data-lpx-thumb]').forEach(function(x){ x.classList.remove('is-on'); }); t.classList.add('is-on'); mainImg.style.opacity = .35; mainImg.onload = function(){ mainImg.style.opacity = 1; }; mainImg.src = t.getAttribute('data-lpx-thumb'); });
    });
    root.querySelectorAll('[data-lp3-size]').forEach(function(b){ b.addEventListener('click', function(){ setTimeout(render, 0); }); });
    var help = pdp.querySelector('[data-lpx-size-help]'), helpBox = pdp.querySelector('[data-lpx-size-help-box]');
    if(help && helpBox) help.addEventListener('click', function(){ helpBox.hidden = !helpBox.hidden; });
    function doAdd(){
      var d = pdp._lpx; if(!d) return;
      var items = (mode === 'set' ? d.vs : [d.vs[0]]).filter(Boolean).map(function(v){ return {id: v.id, quantity: 1}; });
      if(!items.length) return;
      addBtn.classList.add('is-busy'); addLabel.textContent = 'Adding…'; status.textContent = '';
      postItems(items).then(function(res){
        addBtn.classList.remove('is-busy');
        if(!res.ok){ addLabel.textContent = 'Try again'; toast(res.j && res.j.description ? res.j.description : 'Could not add. Please try again.'); return; }
        addLabel.textContent = mode === 'set' ? 'Set added ✓' : 'Added ✓';
        status.textContent = mode === 'set' ? 'Your set is in the cart. The cheapest band comes off at checkout.' : 'Added. Add two more bands and the cheapest is free.';
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, addToCartBtn:addBtn}}));
        setTimeout(function(){ addLabel.textContent = mode === 'set' ? baseLabel : 'Add this band'; }, 2600);
      }).catch(function(){ addBtn.classList.remove('is-busy'); addLabel.textContent = 'Try again'; });
    }
    addBtn.addEventListener('click', doAdd);
    /* phone: a small sticky add bar while the real button is off screen and we are still inside the hero */
    var sticky = document.createElement('div'); sticky.className = 'lpx-sticky';
    sticky.innerHTML = '<div class="lpx-sticky__txt"><b></b><span></span></div><button type="button" class="btn btn-primary">Add</button>';
    root.appendChild(sticky);
    sticky.querySelector('button').addEventListener('click', function(){ addBtn.scrollIntoView({behavior:'smooth', block:'center'}); doAdd(); });
    function renderSticky(){
      var d = pdp._lpx; if(!d) return;
      sticky.querySelector('b').textContent = mode === 'set' ? 'Set of 3, pay for 2' : 'Just this band';
      sticky.querySelector('span').textContent = fmtLike(d.sample, mode === 'set' ? d.set : d.single) + (mode === 'set' ? ', cheapest free' : '');
      sticky.querySelector('button').textContent = mode === 'set' ? 'Add my set' : 'Add';
    }
    function onScroll(){
      if(window.innerWidth > 760){ sticky.classList.remove('is-on'); return; }
      var r = addBtn.getBoundingClientRect(); var h = pdp.getBoundingClientRect();
      var off = r.bottom < 0 || r.top > window.innerHeight;
      var inHero = h.bottom > 120;
      sticky.classList.toggle('is-on', off && inHero && !addBtn.hasAttribute('disabled'));
    }
    window.addEventListener('scroll', onScroll, {passive:true}); window.addEventListener('resize', onScroll);
    render(); onScroll();
  }

  /* ================= D: SINGLE STAT (count-up) ================= */
  var statNum = root.querySelector('[data-lpx-count]');
  if(statNum){
    var raw = statNum.getAttribute('data-lpx-count') || '';
    var digits = raw.replace(/[^\d]/g,'');
    var target = parseInt(digits, 10);
    var reduce = false; try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
    if(target > 0 && !reduce){
      var sep = raw.indexOf(',') > -1 ? ',' : (raw.indexOf('.') > -1 ? '.' : (raw.indexOf(' ') > -1 ? ' ' : ''));
      var suffix = raw.replace(/^[\d.,\s]+/, '');
      var t0 = null, dur = 1400;
      function fmtN(n){ var s = String(n); return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; }
      function step(ts){
        if(!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - k, 3);
        statNum.textContent = fmtN(Math.round(target * e)) + suffix;
        if(k < 1) requestAnimationFrame(step); else statNum.textContent = raw;
      }
      statNum.textContent = fmtN(0) + suffix;
      requestAnimationFrame(step);
    }
  }

  /* ================= E: SET BUILDER ================= */
  var build = root.querySelector('[data-lpx-build]');
  if(build){
    var picks = Array.prototype.slice.call(build.querySelectorAll('[data-lpx-pick]'));
    var bslots = Array.prototype.slice.call(build.querySelectorAll('[data-lpx-bslot]'));
    var set = [null, null, null];
    var bAdd = build.querySelector('[data-lpx-badd]'), bAddLabel = build.querySelector('[data-lpx-badd-label]');
    var bCount = build.querySelector('[data-lpx-bcount]'), bFull = build.querySelector('[data-lpx-bfull]'), bPay = build.querySelector('[data-lpx-bpay]'), bSave = build.querySelector('[data-lpx-bsave]');
    function pickData(el){
      if(el._lpx) return el._lpx;
      var vs = []; try { vs = JSON.parse(el.querySelector('[data-lpx-pick-variants]').textContent); } catch(e){}
      el._lpx = { variants: vs, sizeIdx: parseInt(el.getAttribute('data-size-idx'),10), colorIdx: parseInt(el.getAttribute('data-color-idx'),10), color: el.getAttribute('data-color') || null, handle: el.getAttribute('data-handle'), title: el.getAttribute('data-title') };
      return el._lpx;
    }
    function pickVariant(el){
      var d = pickData(el), size = currentSize();
      var list = d.variants.filter(function(v){ return (d.colorIdx < 0 || !d.color || optVal(v, d.colorIdx) === d.color) && (d.sizeIdx < 0 || sizeMatches(optVal(v, d.sizeIdx), size)); });
      return list.find(function(v){ return v.available; }) || list[0] || null;
    }
    function refreshPick(el){
      var d = pickData(el); var v = pickVariant(el);
      if((!v || !v.available) && d.colorIdx > -1){
        var chips = el.querySelectorAll('[data-lpx-pchip]');
        for(var i=0;i<chips.length;i++){
          var val = chips[i].getAttribute('data-value');
          var alt = d.variants.find(function(x){ return optVal(x, d.colorIdx) === val && x.available && (d.sizeIdx < 0 || sizeMatches(optVal(x, d.sizeIdx), currentSize())); });
          if(alt){ d.color = val; v = alt; break; }
        }
      }
      el.querySelectorAll('[data-lpx-pchip]').forEach(function(c){ c.classList.toggle('is-on', c.getAttribute('data-value') === d.color); });
      var img = el.querySelector('[data-lpx-pick-img]'), price = el.querySelector('[data-lpx-pick-price]'), btn = el.querySelector('[data-lpx-pick-add]');
      if(v && v.img && img.getAttribute('src') !== v.img){ img.style.opacity = .35; img.onload = function(){ img.style.opacity = 1; }; img.src = v.img; }
      if(v) price.textContent = v.price_f;
      d.variant = v;
      var inSet = set.some(function(s){ return s && s.handle === d.handle && s.color === d.color; });
      el.classList.toggle('is-in', inSet);
      if(!v || !v.available){ btn.setAttribute('disabled','disabled'); btn.textContent = 'Sold out in this size'; }
      else { btn.removeAttribute('disabled'); btn.textContent = inSet ? 'In set ✓' : 'Add to set'; }
    }
    function renderSet(){
      var filled = set.filter(Boolean); var n = filled.length;
      var cheapest = n ? Math.min.apply(null, filled.map(function(s){ return s.v.price; })) : 0;
      var freeDone = false;
      bslots.forEach(function(slot, i){
        var s = set[i]; var img = slot.querySelector('img'), t = slot.querySelector('.lpx-bslot__t'), pr = slot.querySelector('.lpx-bslot__p'), x = slot.querySelector('.lpx-bslot__x');
        var isFree = !!(s && n === 3 && !freeDone && s.v.price === cheapest); if(isFree) freeDone = true;
        slot.classList.toggle('is-full', !!s); slot.classList.toggle('is-free', isFree);
        if(s){ img.hidden = false; img.src = s.img || ''; t.innerHTML = '<b>' + s.title.replace(/\s+(Strap|Band)$/i,'') + '</b><span>' + shortColor(s.color || '') + '</span>'; pr.innerHTML = '<b>' + s.v.price_f + '</b>' + (isFree ? '<small>Free</small>' : ''); x.hidden = false; }
        else { img.hidden = true; img.removeAttribute('src'); t.innerHTML = '<b>Band ' + (i+1) + '</b><span>' + (i === 2 ? 'The cheapest one is free' : 'Tap a band to add it') + '</span>'; pr.innerHTML = ''; x.hidden = true; }
      });
      var full = filled.reduce(function(a, s){ return a + s.v.price; }, 0);
      var sample = filled.length ? filled[0].v.price_f : (picks[0] && pickData(picks[0]).variants[0] ? pickData(picks[0]).variants[0].price_f : '$0.00');
      bCount.textContent = n + ' of 3 bands';
      if(n === 3){ bFull.textContent = fmtLike(sample, full); bPay.textContent = fmtLike(sample, full - cheapest); bSave.textContent = 'You save ' + fmtLike(sample, cheapest); bAdd.removeAttribute('disabled'); bAddLabel.textContent = 'Add my set, pay for 2'; }
      else { bFull.textContent = ''; bPay.textContent = n ? fmtLike(sample, full) : ''; bSave.textContent = n ? 'Add ' + (3 - n) + ' more, the cheapest is free' : ''; bAdd.setAttribute('disabled','disabled'); bAddLabel.textContent = n === 0 ? 'Pick your first band' : 'Add ' + (3 - n) + ' more band' + (3 - n > 1 ? 's' : ''); }
      picks.forEach(refreshPick);
      renderBSticky();
    }
    picks.forEach(function(el){
      el.querySelectorAll('[data-lpx-pchip]').forEach(function(c){ c.addEventListener('click', function(){ pickData(el).color = c.getAttribute('data-value'); refreshPick(el); }); });
      el.querySelector('[data-lpx-pick-add]').addEventListener('click', function(){
        var d = pickData(el); var v = d.variant || pickVariant(el); if(!v || !v.available) return;
        var idx = set.findIndex(function(s){ return !s; });
        if(idx === -1){ toast('Your set has three bands. Remove one to swap it.'); return; }
        set[idx] = { handle: d.handle, title: d.title, color: d.color, v: v, img: el.querySelector('[data-lpx-pick-img]').getAttribute('src') };
        renderSet();
        var n = set.filter(Boolean).length;
        if(n === 3){ toast('Set complete. The cheapest band is free.'); if(window.innerWidth <= 760) bAdd.scrollIntoView({behavior:'smooth', block:'center'}); }
        else toast(n + ' of 3 in your set. Add ' + (3 - n) + ' more, the cheapest is free.');
      });
    });
    bslots.forEach(function(slot, i){ slot.querySelector('.lpx-bslot__x').addEventListener('click', function(){ set.splice(i, 1); set.push(null); renderSet(); }); });
    root.querySelectorAll('[data-lp3-size]').forEach(function(b){ b.addEventListener('click', function(){ setTimeout(function(){
      /* re-resolve chosen bands in the new size */
      set = set.map(function(s){ if(!s) return s; var el = picks.find(function(p){ return pickData(p).handle === s.handle; }); if(!el) return s; var d = pickData(el); var keep = d.color; d.color = s.color; var v = pickVariant(el); d.color = keep; return v && v.available ? Object.assign({}, s, {v: v, img: v.img || s.img}) : null; });
      renderSet();
    }, 0); }); });
    bAdd.addEventListener('click', function(){
      var items = set.filter(Boolean).map(function(s){ return {id: s.v.id, quantity: 1}; }); if(items.length < 3) return;
      bAdd.classList.add('is-busy'); bAddLabel.textContent = 'Adding your set…';
      postItems(items).then(function(res){
        bAdd.classList.remove('is-busy');
        if(!res.ok){ bAddLabel.textContent = 'Try again'; toast(res.j && res.j.description ? res.j.description : 'Could not add. Please try again.'); return; }
        bAddLabel.textContent = 'Set added ✓';
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, addToCartBtn:bAdd}}));
        setTimeout(function(){ bAddLabel.textContent = 'Add my set, pay for 2'; }, 2600);
      }).catch(function(){ bAdd.classList.remove('is-busy'); bAddLabel.textContent = 'Try again'; });
    });
    /* phone: sticky set bar while the real button is off screen inside the hero */
    var bSticky = document.createElement('div'); bSticky.className = 'lpx-sticky';
    bSticky.innerHTML = '<div class="lpx-sticky__txt"><b></b><span></span></div><button type="button" class="btn btn-primary">Add</button>';
    root.appendChild(bSticky);
    bSticky.querySelector('button').addEventListener('click', function(){ var n = set.filter(Boolean).length; if(n === 3) bAdd.click(); else build.querySelector('[data-lpx-picker]').scrollIntoView({behavior:'smooth', block:'start'}); });
    function renderBSticky(){
      var n = set.filter(Boolean).length;
      bSticky.querySelector('b').textContent = n === 3 ? 'Set complete, 3rd band free' : (n + ' of 3 in your set');
      bSticky.querySelector('span').textContent = n === 3 ? bPay.textContent + ' for three' : (n ? 'Add ' + (3 - n) + ' more, cheapest is free' : 'Tap any three bands');
      bSticky.querySelector('button').textContent = n === 3 ? 'Add my set' : 'Pick bands';
    }
    function onBScroll(){
      if(window.innerWidth > 760){ bSticky.classList.remove('is-on'); return; }
      var r = bAdd.getBoundingClientRect(); var h = build.getBoundingClientRect();
      var off = r.bottom < 0 || r.top > window.innerHeight; var inHero = h.bottom > 120 && h.top < window.innerHeight - 200;
      bSticky.classList.toggle('is-on', off && inHero);
    }
    window.addEventListener('scroll', onBScroll, {passive:true}); window.addEventListener('resize', onBScroll);
    renderSet(); onBScroll();
  }

  /* ================= C: QUIZ ================= */
  var quiz = root.querySelector('[data-lpx-quiz]');
  if(quiz){
    var MAP = {
      gold:   ['atlanta-metal-strap','nova-stainless-band','kyra-metal-strap-6-colours','stainless-steel-strap-for-apple-watch','arya-stainless-strap','kyoto-metal-strap-4-colours','sorelle-ceramic-watch-band','perla-ceramic-strap'],
      silver: ['nova-stainless-band','kyra-metal-strap-6-colours','stella-magnetic-stainless-band','stainless-steel-strap-for-apple-watch','arya-stainless-strap','granum-ceramic-strap','perla-ceramic-strap','atlanta-metal-strap'],
      rose:   ['sorelle-ceramic-watch-band','kyra-metal-strap-6-colours','granum-ceramic-strap','stella-magnetic-stainless-band','stainless-steel-strap-for-apple-watch','arya-stainless-strap','perla-ceramic-strap','nova-stainless-band'],
      mixed:  ['themis-stainless-band-4-colours','perla-ceramic-strap','aura-metal-band','nova-stainless-band','atlanta-metal-strap','kyra-metal-strap-6-colours']
    };
    var USE = { work:'nova-stainless-band', everyday:'perla-ceramic-strap', active:'terra-nylon-loop-band' };
    var USE_TXT = { work:'work and dinners', everyday:'everyday', active:'walks, gym and sleep' };
    var METAL_TXT = { gold:'gold', silver:'silver', rose:'rose gold', mixed:'mixed metals' };
    var KEY = { gold:/gold/i, silver:/silver|steel/i, rose:/rose/i };
    var ans = {size:null, metal:null, use:null};
    var stepLabel = quiz.querySelector('[data-lpx-step-label]'), bar = quiz.querySelector('[data-lpx-bar]');
    function show(id){
      quiz.querySelectorAll('[data-lpx-q]').forEach(function(q){ q.classList.toggle('is-on', q.getAttribute('data-lpx-q') === String(id)); });
      var n = parseInt(id,10);
      if(n){ stepLabel.textContent = 'Question ' + n + ' of 3'; bar.style.width = (n*33) + '%'; }
      else if(id === 'loading'){ stepLabel.textContent = 'Matching'; bar.style.width = '100%'; }
      else { stepLabel.textContent = 'Your result'; bar.style.width = '100%'; }
      if(window.innerWidth <= 760){ var card = quiz.querySelector('[data-lpx-quiz-card]'); var top = card.getBoundingClientRect().top; if(top < 0 || top > 160) window.scrollTo({top: window.scrollY + top - 70, behavior:'smooth'}); }
    }
    quiz.querySelectorAll('[data-lpx-answer]').forEach(function(b){
      b.addEventListener('click', function(){
        var k = b.getAttribute('data-lpx-answer'); ans[k] = b.getAttribute('data-val');
        b.parentNode.querySelectorAll('[data-lpx-answer]').forEach(function(x){ x.classList.remove('is-on'); }); b.classList.add('is-on');
        setTimeout(function(){
          if(k === 'size') show(2); else if(k === 'metal') show(3); else runLoading();
        }, 260);
      });
    });
    function runLoading(){
      show('loading');
      var t = quiz.querySelector('[data-lpx-loading-text]');
      var msgs = ['Checking your size, ' + sizeLabels[ans.size] + '…', 'Matching ' + METAL_TXT[ans.metal] + ' bands…', 'Picking 3 of our 27 bands…'];
      var i = 0; t.textContent = msgs[0];
      var iv = setInterval(function(){ i++; if(i < msgs.length) t.textContent = msgs[i]; else { clearInterval(iv); buildResult(); } }, 650);
    }
    function cardByHandle(h){ return root.querySelector('[data-lp3-card][data-handle="' + h + '"]'); }
    function pickColor(card){
      if(!ans.metal || ans.metal === 'mixed' || !KEY[ans.metal]) return;
      var chips = card.querySelectorAll('[data-lp3-chip]');
      var want = null;
      for(var i=0;i<chips.length;i++){
        var v = chips[i].getAttribute('data-value') || '';
        if(ans.metal === 'gold' && /rose/i.test(v)) continue;
        if(KEY[ans.metal].test(v)){ want = chips[i]; break; }
      }
      if(want && !want.classList.contains('is-on')) want.click();
    }
    function pickFrom(list, exclude){
      for(var i=0;i<list.length;i++){
        if(exclude.indexOf(list[i]) > -1) continue;
        var c = cardByHandle(list[i]); if(!c) continue;
        pickColor(c);
        var v = c._lp3 && c._lp3.variant; if(v && v.available) return list[i];
      }
      return null;
    }
    var picks = [];
    function buildResult(){
      picks = [];
      var useH = pickFrom([USE[ans.use]], []); if(useH) picks.push(useH);
      var mh = MAP[ans.metal] || MAP.mixed;
      while(picks.length < 3){ var h = pickFrom(mh, picks); if(!h) break; picks.push(h); }
      if(picks.length < 3){ root.querySelectorAll('[data-lp3-card]').forEach(function(c){ if(picks.length < 3){ var h = c.getAttribute('data-handle'); if(picks.indexOf(h) === -1 && c._lp3 && c._lp3.variant && c._lp3.variant.available) picks.push(h); } }); }
      var list = quiz.querySelector('[data-lpx-result-list]'); list.innerHTML = '';
      var vs = picks.map(function(h){ var c = cardByHandle(h); return {card:c, v:c._lp3.variant}; });
      var cheapest = Math.min.apply(null, vs.map(function(x){ return x.v.cents; }));
      var full = 0, freeDone = false;
      vs.forEach(function(x){
        full += x.v.cents;
        var isFree = !freeDone && x.v.cents === cheapest; if(isFree) freeDone = true;
        var title = x.card.querySelector('.lp3-card__title').textContent.trim();
        var img = x.card.querySelector('[data-lp3-img]').getAttribute('src');
        var color = x.card.getAttribute('data-color-idx') > -1 ? shortColor(optVal(x.v, parseInt(x.card.getAttribute('data-color-idx'),10))) : '';
        var row = document.createElement('div'); row.className = 'lpx-res' + (isFree ? ' lpx-res--free' : '');
        row.innerHTML = '<div class="lpx-res__img"><img src="' + img + '" alt=""></div><div class="lpx-res__t"><b>' + title + '</b><span>' + (color ? color + ' · ' : '') + sizeLabels[ans.size] + '</span></div><div class="lpx-res__p"><b>' + x.v.price + '</b>' + (isFree ? '<small>Free</small>' : '') + '</div>';
        list.appendChild(row);
      });
      var sample = vs[0] ? vs[0].v.price : '$0.00';
      quiz.querySelector('[data-lpx-res-full]').textContent = fmtLike(sample, full);
      quiz.querySelector('[data-lpx-res-price]').textContent = fmtLike(sample, full - cheapest);
      quiz.querySelector('[data-lpx-result-sub]').textContent = 'For a ' + sizeLabels[ans.size] + ' watch, ' + METAL_TXT[ans.metal] + ', worn for ' + USE_TXT[ans.use] + '. Tap a band below to swap it.';
      show('result');
    }
    quiz.querySelector('[data-lpx-restart]').addEventListener('click', function(){ ans = {size:null, metal:null, use:null}; quiz.querySelectorAll('[data-lpx-answer]').forEach(function(x){ x.classList.remove('is-on'); }); show(1); });
    var addSet = quiz.querySelector('[data-lpx-add-set]'), addSetLabel = addSet.querySelector('[data-lpx-add-label]'); var addSetBase = addSetLabel.textContent;
    addSet.addEventListener('click', function(){
      var items = picks.map(function(h){ var c = cardByHandle(h); return {id: c._lp3.variant.id, quantity: 1}; });
      if(items.length < 3){ toast('Pick three bands below'); return; }
      addSet.classList.add('is-busy'); addSetLabel.textContent = 'Adding your set…';
      postItems(items).then(function(res){
        addSet.classList.remove('is-busy');
        if(!res.ok){ addSetLabel.textContent = 'Try again'; toast(res.j && res.j.description ? res.j.description : 'Could not add. Please try again.'); return; }
        addSetLabel.textContent = 'Set added ✓';
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, addToCartBtn:addSet}}));
        setTimeout(function(){ addSetLabel.textContent = addSetBase; }, 2600);
      }).catch(function(){ addSet.classList.remove('is-busy'); addSetLabel.textContent = 'Try again'; });
    });
    /* remember a size already chosen on another page: pre-mark it, still ask (it is the first question) */
    var s = currentSize(); quiz.querySelectorAll('[data-lpx-answer="size"]').forEach(function(b){ b.classList.toggle('is-on', parseInt(b.getAttribute('data-val'),10) === s); });
  }
})();
